import { ReactComponent as ChangePasswordErrorIcon } from "../../../../../assets/svg/change-password-error.svg";
import { IWizardConfig } from "../../../../wizard/types";
import useUserQueries from "../../../hooks/useUserQueries";
import ChangePasswordForm from "./ChangePasswordForm";
import validator from "./validator";

export function useChangePasswordConfig(): IWizardConfig {
  const { changePassword } = useUserQueries();

  return {
    steps: [
      {
        titleConfig: {
          ErrorIcon: ChangePasswordErrorIcon,
          titleText: "Change Password",
        },
        content: ChangePasswordForm,
        validator: validator,
      },
    ],
    saveCallback: changePassword,
    submitButtonText: "Save",
    cancelButtonText: null,
  };
}
